import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp, Cookie } from 'lucide-react';

const cookies = [
  {
    id: 1,
    title: "Cookie Tecnici Necessari",
    content: `Nome: jwtToken
Scopo: Mantiene la sessione di autenticazione dell'utente loggato
Durata: Sessione (sessionStorage) o persistente (localStorage) in base alla scelta dell'utente
Tipo: First-party
Necessario: Sì — il sito non funziona correttamente senza questo cookie

Nome: cookieConsent
Scopo: Memorizza la scelta dell'utente riguardo ai cookie
Durata: Persistente (senza scadenza)
Tipo: First-party
Necessario: Sì — richiesto dalla legge per registrare il consenso`
  },
  {
    id: 2,
    title: "Cookie di Sessione",
    content: `Nome: user
Scopo: Memorizza i dati base dell'utente autenticato (nome, email)
Durata: Sessione o persistente in base alla scelta cookies
Tipo: First-party
Necessario: Sì — per mostrare le informazioni dell'utente nell'interfaccia

Nome: currentBooking
Scopo: Memorizza temporaneamente i dati della prenotazione in corso
Durata: Durata della sessione di prenotazione
Tipo: First-party
Necessario: Sì — per mantenere i dati durante il flusso di acquisto`
  },
  {
    id: 3,
    title: "Cookie di Terze Parti — Stripe (Pagamenti)",
    content: `Fornitore: Stripe Inc.
Scopo: Gestione sicura dei pagamenti online
Durata: Variabile (definita da Stripe)
Tipo: Third-party
Necessario: Sì — richiesto per completare i pagamenti
Informativa Stripe: https://stripe.com/it/privacy`
  },
  {
    id: 4,
    title: "Cookie Non Utilizzati",
    content: `Questo sito NON utilizza:
- Cookie di profilazione pubblicitaria
- Cookie di social media tracking
- Google Analytics o altri strumenti di analisi comportamentale
- Pixel di tracciamento Facebook/Meta

Nessun dato viene venduto a terzi per scopi pubblicitari.`
  },
  {
    id: 5,
    title: "Come Gestire i Cookie",
    content: `Puoi controllare i cookie nei seguenti modi:

1. Tramite il banner cookie sul nostro sito — clicca "Accetta" o "Rifiuta" al primo accesso.

2. Tramite le impostazioni del tuo browser:
   - Chrome: Impostazioni → Privacy e sicurezza → Cookie
   - Firefox: Impostazioni → Privacy e sicurezza
   - Safari: Preferenze → Privacy
   - Edge: Impostazioni → Cookie e autorizzazioni sito

3. Contattandoci a: privacy@cafpraticheonline.it

Nota: disabilitare i cookie tecnici necessari può compromettere il funzionamento del sito.`
  }
];

const AccordionItem = ({ item, isOpen, onToggle }) => (
  <div style={{ borderBottom: '1px solid rgba(242,194,49,0.2)', overflow: 'hidden' }}>
    <button
      onClick={onToggle}
      style={{
        width: '100%', display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', padding: '18px 24px',
        background: isOpen ? 'linear-gradient(90deg, rgba(242,194,49,0.08), transparent)' : 'transparent',
        border: 'none', cursor: 'pointer', textAlign: 'left',
      }}
    >
      <span style={{ color: isOpen ? '#F2C231' : '#CBD5E1', fontWeight: isOpen ? '700' : '600', fontSize: '0.95rem' }}>
        {item.title}
      </span>
      <span style={{ color: '#F2C231', flexShrink: 0, marginLeft: '12px' }}>
        {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </span>
    </button>
    <div style={{ maxHeight: isOpen ? '1500px' : '0', overflow: 'hidden', transition: 'max-height 0.4s ease' }}>
      <div style={{ padding: '4px 24px 24px', color: '#94A3B8', fontSize: '0.875rem', lineHeight: '1.85', whiteSpace: 'pre-wrap', fontFamily: 'Arial, sans-serif' }}>
        {item.content}
      </div>
    </div>
  </div>
);

const CookiePolicyPage = () => {
  const [openItem, setOpenItem] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(160deg, #0F2030 0%, #182F40 50%, #1D3A50 100%)', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ padding: '64px 32px 48px', textAlign: 'center', opacity: visible ? 1 : 0, transition: 'opacity 0.7s ease' }}>
        <div style={{ width: '60px', height: '3px', background: 'linear-gradient(90deg, #F2C231, #C69A32)', margin: '0 auto 24px', borderRadius: '2px' }} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '16px' }}>
          <Cookie size={28} color="#F2C231" />
          <h1 style={{ color: '#F2C231', fontSize: 'clamp(1.6rem, 4vw, 2.4rem)', fontWeight: '700', margin: 0 }}>
            Cookie Policy
          </h1>
        </div>
        <p style={{ color: '#94A3B8', fontSize: '0.9rem', maxWidth: '560px', margin: '0 auto', lineHeight: '1.7' }}>
          Ai sensi della Direttiva ePrivacy UE e del Regolamento GDPR 2016/679<br />
          Ultimo aggiornamento: Gennaio 2026
        </p>
        <div style={{ width: '60px', height: '3px', background: 'linear-gradient(90deg, #C69A32, #F2C231)', margin: '24px auto 0', borderRadius: '2px' }} />
      </div>

      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '0 24px 80px', opacity: visible ? 1 : 0, transition: 'opacity 0.7s ease 0.2s' }}>
        <div style={{ background: 'rgba(242,194,49,0.05)', border: '1px solid rgba(242,194,49,0.2)', borderRadius: '12px', padding: '20px 28px', color: '#94A3B8', fontSize: '0.875rem', lineHeight: '1.9', marginBottom: '24px', fontFamily: 'Arial, sans-serif' }}>
          Questo sito utilizza cookie tecnici necessari al suo funzionamento. Alcuni cookie di terze parti (Stripe) vengono attivati solo durante il processo di pagamento. Non utilizziamo cookie di profilazione o pubblicitari senza il tuo esplicito consenso.
        </div>

        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(242,194,49,0.15)', borderRadius: '16px', overflow: 'hidden' }}>
          {cookies.map(item => (
            <AccordionItem
              key={item.id}
              item={item}
              isOpen={openItem === item.id}
              onToggle={() => setOpenItem(openItem === item.id ? null : item.id)}
            />
          ))}
        </div>
        <p style={{ textAlign: 'center', color: 'rgba(148,163,184,0.45)', fontSize: '0.75rem', marginTop: '32px', letterSpacing: '0.04em' }}>
          © 2026 CAF DIPENDENTI E PENSIONATI AIC SRL · Per domande: privacy@cafpraticheonline.it
        </p>
      </div>
    </div>
  );
};

export default CookiePolicyPage;